<template>
  <Teleport to="body">
    <transition name="dialog-fade">
      <div v-if="modelValue" class="tx-dialog-overlay" :style="{ zIndex: currentZIndex }"
        @click.self="handleOverlayClick">
        <div class="tx-dialog-content">
          <slot />
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref, watch } from 'vue';
import { useDialogStack } from '../hooks/useDialogStack';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  closeOnClickOverlay: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['update:modelValue','close']);

// 使用 v-model 代理
const model = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
});

// 初始化 dialog 状态
let dialogStack = null;
const currentZIndex = ref(1000);

function initDialog() {
  if (!dialogStack) {
    dialogStack = useDialogStack();
    currentZIndex.value = dialogStack.zIndex;
  }
}

function cleanupDialog() {
  if (dialogStack) {
    dialogStack.dispose();
    dialogStack = null;
  }
}

function handleOverlayClick() {
  if (props.closeOnClickOverlay) {
    model.value = false;
  }
}

// 监听 model 变化
watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal) {
      initDialog();
    } else {
      cleanupDialog();
      emit('close')
    }
  },
  { immediate: true }
);

onMounted(() => {
  if (props.modelValue) {
    initDialog();
  }
});

onBeforeUnmount(() => {
  cleanupDialog();
});
</script>

<style scoped lang="scss">
.tx-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
}

.tx-dialog-content {
  /* 子内容由 slot 决定，不设固定样式 */
  // max-width: calc(100vw - 32px);
  max-height: calc(100vh - 64px);
  overflow: auto;
}

/* 淡入淡出动画 */
.dialog-fade-enter-active,
.dialog-fade-leave-active {
  transition: opacity 0.25s ease;
}

.dialog-fade-enter-from,
.dialog-fade-leave-to {
  opacity: 0;
}
</style>
